// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c419db2f","845":"34d8df5d"}[chunkId] + ".chunk.js";
};